<template>
  <div class="invoices-index width-100">
    <TableWrapper
      v-if="!loading"
      :table-columns="invoicesColumns"
      table-key="invoices"
      :enable-selection="false"
      @showInvoice="showInvoice"
      @showAttachment="showAttachment"
    />
  </div>
</template>

<script>
import fileSaver from 'file-saver';
import { mapActions, mapGetters } from 'vuex';
import { invoicesColumns } from '@/config';
import { invoicesApi } from '@/api';
import TableWrapper from '@/components/TableWrapper.vue';

export default {
  name: 'InvoicesIndex',
  components: {
    TableWrapper,
  },
  data() {
    return {
      loading: false,
      invoicesColumns,
    };
  },
  computed: {
    ...mapGetters([
      'filtersStatus',
      'tableFilters',
    ]),
  },
  created() {
    this.parseQueryStringStatus(this.$route.query);
    this.getTableRows(this.$route.query);
  },
  beforeRouteUpdate(to, from, next) {
    this.parseQueryStringStatus(to.query);
    this.getTableRows(to.query);
    next();
  },
  methods: {
    ...mapActions([
      'updateTableRows',
      'updateTableCount',
      'parseQueryStringStatus',
    ]),
    async getTableRows() {
      try {
        this.loading = true;
        const invoicesIndexResponse = await invoicesApi.index(this.tableFilters('invoices'), this.filtersStatus.invoices);
        const invoicesCountResponse = await invoicesApi.count(this.filtersStatus.invoices);
        this.updateTableRows({ tableKey: 'invoices', rows: invoicesIndexResponse.data });
        this.updateTableCount({ tableKey: 'invoices', count: invoicesCountResponse.data.count });
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.$notify({ showClose: true, type: 'error', message: error.response.data.error.message });
      }
    },
    async showInvoice(row) {
      try {
        this.loading = true;
        const file = await invoicesApi.getInvoicePdf(row.orderId);
        if (file.data) {
          return fileSaver.saveAs(file.data, 'filename.pdf');
        }
        this.loading = false;
        return file;
      } catch (error) {
        this.loading = false;
        return error;
      }
    },
    async showAttachment(row) {
      try {
        this.loading = true;
        const file = await invoicesApi.getAttachmentPdf(row.orderId);
        if (file.data) {
          return fileSaver.saveAs(file.data, 'filename.pdf');
        }
        this.loading = false;
        return file;
      } catch (error) {
        this.loading = false;
        return error;
      }
    },
  },
};
</script>
